"use strict";

const Parallel = require("paralleljs");

class POW {
  constructor(options) {
    this.options = Object.assign(
      {
        workersTimeoutInSeconds: 10,
        sha3Path: "./sha3.js",
        evalPath: "./eval.js",
      },
      options
    );
    this.isSupported = Parallel.isSupported;
  }

  isSupported() {
    return Parallel.isSupported;
  }

  solve(challenge) {
    return this.spawnWorker(challenge);
  }

  spawnWorker(challenge) {
    const timeoutAt =
      new Date().getTime() / 1000 + this.options.workersTimeoutInSeconds;

    const p = new Parallel(
      { challenge, timeoutAt },
      {
        evalPath: this.options.evalPath,
      }
    );

    p.require(this.options.sha3Path);
    return new Promise((resolve) => {
      p.spawn(workerTask).then(resolve);
    });
  }
}

function workerTask(args) {
  const { challenge, timeoutAt } = args;
  const { complexity, seed, timestamp } = challenge;

  const buildHeader = ({ ver, complexity, timestamp, seed, counter }) => {
    return [ver, complexity, timestamp, seed, counter].join(":");
  };

  const isHashMatched = (str) => {
    const prefix = "".padStart(complexity, "0");
    return SHA(str).startsWith(prefix);
  };

  const isTimeLimit = () => {
    var now = Date.now() / 1000;
    return timeoutAt < now;
  };

  let counter = 0;

  while (true) {
    if (counter % 1000 === 0 && isTimeLimit()) {
      return -1;
    }
    const header = buildHeader({
      ver: "1",
      complexity,
      timestamp,
      seed,
      counter,
    });

    if (isHashMatched(header)) {
      return seed + ":" + counter;
    }

    counter += 1;
  }
}

module.exports = POW;
